<div *ngIf="!isAppReady">
  <div class="login-wrapper">
    <div class="login-form">
      <div class="login-logo"></div>
      <sh-loading-indicator class="text-center d-block"></sh-loading-indicator>
    </div>
  </div>
</div>
<div *ngIf="isAppReady">
  <ng-content *ngIf="layoutService.showBaseLayout" select="[sidebar]"></ng-content>
  <div>
    <div
      id="sh_content_wrapper"
      [class.hide-base]="!layoutService.showBaseLayout"
      [ngClass]="{ sh_content_wrapper_expanded: toggleSidebar }"
    >
    <div id="sh_header_wrapper" *ngIf="layoutService.showBaseLayout">
      <ng-content select="[header]"></ng-content>
    </div>
      <div
        id="sh_content_body"
        [class.hide-base]="!layoutService.showBaseLayout"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
